import { Navigate } from '@sorare/routing';

import { FOOTBALL_PLAY_RIVALS_ARENA } from '@sorare/core/src/constants/__generated__/routes';

const RivalsPage = () => {
  return <Navigate to={FOOTBALL_PLAY_RIVALS_ARENA} replace />;
};
export default RivalsPage;
